<template>
  <div>
    <v-tooltip
      left
      :open-on-focus="false"
      :open-on-click="false"
      :color="inverted ? 'white' : undefined"
      :content-class="inverted ? 'black--text' : undefined"
    >
      <!--      eslint-disable-next-line-->
      <template #activator="{ on }">
        <v-btn
          v-show="showNeedHelp || showNeedHelpFab"
          fixed
          class="need-help-activator mr-2"
          data-cy="needHelpActivator"
          fab
          color="primary"
          v-on="{
            click: () => (showNeedHelpContacts = !showNeedHelpContacts)
          }"
        >
          <v-icon v-if="showNeedHelpContacts" color="white">$cross</v-icon>
          <v-icon v-else color="white">$dropSmall</v-icon>
          {{ $t('dashboard.supportBox.openTitle') }}
        </v-btn>
      </template>
      {{ $t('dashboard.needHelp') }}
    </v-tooltip>
    <v-scale-transition origin="bottom right 0">
      <div
        v-show="showNeedHelpContacts"
        class="need-help-contacts text-center pa-4 rounded-lg white border"
      >
        <div class="image-container mb-1 mt-2">
          <v-img width="104" height="40" contain :src="$asset(`img/support.png`)" />
        </div>
        <div :class="isHu ? 'mt-4' : ''" class="support-box-holder mb-3">
          <div class="support-box-text">
            {{ $t('dashboard.supportBox.boxText') }}
          </div>
        </div>
        <div class="support-box-container">
          <SupportBox
            v-for="(supportBox, index) in supportBoxes"
            :key="index"
            :title="supportBox.title"
            :text="supportBox.text"
            :icon="supportBox.icon"
            max-width="320"
            :buttons="supportBox.buttons"
            :outage="supportBox.outage"
          />
        </div>
      </div>
    </v-scale-transition>
  </div>
</template>

<script>
import SupportBox from '@/components/Molecules/SupportBox.vue';
import customerService from '@/mixins/customerService';
export default {
  name: 'NeedHelpFab',
  components: { SupportBox },
  mixins: [customerService],
  props: {
    showNeedHelpFab: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.need-help-activator {
  z-index: 205;
  bottom: 20px;
  right: 20px;
  width: 190px;
  height: 48px;
  border-radius: 45px;
  gap: 8px;
  &:hover,
  &:active,
  &:focus {
    &:before {
      opacity: 0;
    }
  }
}
.support-box-container {
  max-height: 320px;
  overflow-y: auto;
}
.need-help-contacts {
  z-index: 206;
  position: fixed;
  bottom: 83px;
  right: 20px;
  box-shadow: 0 8px 10px -5px rgba($black, 0.1);
  max-height: 560px;
  overflow-y: auto;
}

.contact-divider {
  height: 32px;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.support-box-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.support-box-text {
  height: 40px;
  width: 204px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #6f8693;
}
</style>
